import { render, staticRenderFns } from "./CedantInfo.vue?vue&type=template&id=11a14c3c&"
import script from "./CedantInfo.vue?vue&type=script&lang=js&"
export * from "./CedantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports